// Rodolfo Rivas
// 2017
//*************************************************************//
//                                                             //
//    ╔═╗┌─┐┌┬┐┌─┐┌─┐┌┐┌┌─┐┌┐┌┌┬┐┌─┐  ┬ ┬┌─┐┬ ┬┌─┐┬─┐┬┌─┐      //
//    ║  │ ││││├─┘│ ││││├┤ │││ │ ├┤   │ │└─┐│ │├─┤├┬┘││ │      //
//    ╚═╝└─┘┴ ┴┴  └─┘┘└┘└─┘┘└┘ ┴ └─┘  └─┘└─┘└─┘┴ ┴┴└─┴└─┘      //
//                                                             //
//*************************************************************//


import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import "rxjs/Rx";
import {UtilConfig} from "../../../../autenticacion/servicios/UtilConfig";
import * as moment from 'moment';
import {BsDatepickerConfig, BsLocaleService} from 'ngx-bootstrap/datepicker';
import {WebServices} from "../../../recursos/modelo/consumerModel/web-services.enum";
import {ConsumerService} from "../../../recursos/servicio/consumer.service";

declare const $: any;

declare var swal: any;

declare let d3: any;


@Component({
    selector: 'app-reporteGeneral',
    templateUrl: './view/general.component.html',
    styleUrls: ['./css/general.component.scss'],
    providers: [ConsumerService]
})
export class GeneralComponent implements OnInit {

//        ╦┌┐┌┬┌┬┐    ┬ ┬  ╔═╗┌─┐┌┐┌┌─┐┌┬┐┬─┐┬ ┬┌─┐┌┬┐┌─┐┬─┐
//        ║││││ │     └┬┘  ║  │ ││││└─┐ │ ├┬┘│ ││   │ │ │├┬┘
//        ╩┘└┘┴ ┴      ┴   ╚═╝└─┘┘└┘└─┘ ┴ ┴└─└─┘└─┘ ┴ └─┘┴└─

    // ITEM DEL CRUD
    origenCRUD = "Reporte";
    // variables de pantalla
    mensaje;
    loading = false;
    cargandoList = true;
    // VARIABLES DE SEGURIDAD
    authorities = {
        ROLE_REPORTE_OPERACIONES_AUDITORIA: false,
        ROLE_REPORTE_USUARIOS_POR_ROL: false,
        ROLE_REPORTE_TRANSACCIONES_EMISOR: false,
        ROLE_REPORTE_TRANSACCIONES_SUNAT: false,
        ROLE_REPORTE_EST_DOCUMENTO: false,
        ROLE_REPORTE_DOCUMENTOS_ERROR: false,
    };

    emisores: any[];
    tipoDocumento: any[];
    empresaAdministradora = false;

    ESCON_CUSTOMER = 1;
    // MODELO REPORTES

    rangeDates: Date[];
    locale = 'es';
    colorTheme = 'theme-dark-blue';
    bsConfig: Partial<BsDatepickerConfig>;

    REPORT_AUDITORIA = this.jwtUtil.URL_WS_BACKEND + "/reporte/emitir?" +
        "reporte.id=1&" +
        "reporte.nombre=Reporte de operaciones&" +
        "reporte.fileName=rptOperacionesAuditoria&" +
        "reporte.urlJasper=general/rptOperacionesAuditoria.jasper&";

    reporteAuditoria = {
        rangoFechas: this.rangeDates,
        linkExcel: "",
        linkPdf: ""
    };

    REPORT_USUARIOS = this.jwtUtil.URL_WS_BACKEND + "/reporte/emitir?" +
        "reporte.id=2&" +
        "reporte.nombre=Reporte de Usuarios de Empresas&" +
        "reporte.fileName=rptUsuariosPorEmpresa&" +
        "reporte.urlJasper=general/rptUsuariosPorEmpresa.jasper&";
    reporteUsuarios = {
        idEmpresa: "",
        linkExcel: "",
        linkPdf: ""
    };

    REPORT_TRANSACCIONES = this.jwtUtil.URL_WS_BACKEND + "/reporte/emitir?" +
        "reporte.id=3&" +
        "reporte.nombre=Reporte de Transacciones&" +
        "reporte.fileName=rptEmisor&" +
        "reporte.urlJasper=ose/rptEmisor.jasper&" +
        "estado-NUMERO=-1&";
    reporteTransacciones = {
        idEmpresa: "",
        rangoFechas: this.rangeDates,
        tipoDocumento: "",
        linkExcel: "",
        linkPdf: ""
    };

    REPORT_ESTADISTICO_TRANSACCIONES = this.jwtUtil.URL_WS_BACKEND + "/reporte/emitir?" +
        "reporte.id=5&" +
        "reporte.nombre=Reporte Estadistico Transacciones&" +
        "reporte.fileName=rptEstadisticasDoc&" +
        "reporte.urlJasper=ose/rptEstadisticasDoc.jasper&";
    reporteEstadisticoTransacciones = {
        idEmpresa: "",
        rangoFechas: this.rangeDates,
        tipoDocumento: "",
        linkExcel: "",
        linkPdf: "",
        empresa: ""
    };

    REPORT_TRANSACCIONES_ERROR = this.jwtUtil.URL_WS_BACKEND + "/reporte/emitir?" +
        "reporte.id=6&" +
        "reporte.nombre=Reporte de Transacciones por errores&" +
        "reporte.fileName=rptDocumentosError&" +
        "reporte.urlJasper=ose/rptDocumentosError.jasper&";
    reporteTransaccionesError = {
        idEmpresa: "",
        rangoFechas: this.rangeDates,
        tipoDocumento: "",
        codigoError: "",
        linkExcel: "",
        linkPdf: ""
    };

    REPORT_TRANSACCIONES_SUNAT = this.jwtUtil.URL_WS_BACKEND + "/reporte/emitir?" +
        "reporte.id=4&" +
        "reporte.nombre=Reporte de Transacciones SUNAT&" +
        "reporte.fileName=rptSunat&" +
        "reporte.urlJasper=ose/rptSunat.jasper&" +
        "estado-NUMERO=-1&";

    reporteTransaccionesSunat = {
        idEmpresa: "",
        rangoFechas: this.rangeDates,
        tipoDocumento: "",
        linkExcel: "",
        linkPdf: ""
    };

    es;
    empresaSession;

    constructor(private route: ActivatedRoute,
                private router: Router,
                public jwtUtil: UtilConfig,
                public consumerService: ConsumerService,
                private _localeService: BsLocaleService) {

        this._localeService.use(this.locale);
        this.bsConfig = Object.assign({}, {containerClass: this.colorTheme, showWeekNumbers: false});
        // VERIFICA LOS PERMISOS DEL LOG LOGEADO
        this.authorities = jwtUtil.verificarAuthorities(this.authorities);
        var fechaIni = (new Date().getMonth() + 1) + "/01/" + new Date().getFullYear();
        this.es = jwtUtil.CONFIG_ES_CALENDAR;

        this.empresaSession = jwtUtil.getCurrentUser().customer;
        // SI LA EMPRESA ES ESCON SE HABILITAN LOS SELECT
        if (this.empresaSession.id == jwtUtil.ESCON_CUSTOMER)
            this.empresaAdministradora = true;
        //REPORTE AUDITORIA

        this.reporteAuditoria.rangoFechas = [new Date(fechaIni), new Date()];
        this.reporteAuditoria.linkExcel = this.REPORT_AUDITORIA +
            "formato=EXCEL&" +
            "authorization=" + jwtUtil.getJwtToken() + "&" +
            "fechaDesde-FECHA=" + moment(this.reporteAuditoria.rangoFechas[0]).format("YYYY-MM-DD") + "&" +
            "fechaHasta-FECHA=" + moment(this.reporteAuditoria.rangoFechas[1]).format("YYYY-MM-DD");

        this.reporteAuditoria.linkPdf = this.REPORT_AUDITORIA +
            "formato=PDF&" +
            "authorization=" + jwtUtil.getJwtToken() + "&" +
            "fechaDesde-FECHA=" + moment(this.reporteAuditoria.rangoFechas[0]).format("YYYY-MM-DD") + "&" +
            "fechaHasta-FECHA=" + moment(this.reporteAuditoria.rangoFechas[1]).format("YYYY-MM-DD");


        //REPORTE USUARIOS
        this.emisores = [];
        this.emisores.push({label: 'Todos los contribuyentes', value: "-1"});
        this.consultarCombos();
        this.reporteUsuarios.idEmpresa = this.empresaSession.id;
        this.reporteUsuarios.linkExcel = this.REPORT_USUARIOS +
            "formato=EXCEL&" +
            "authorization=" + jwtUtil.getJwtToken() + "&" +
            "idEmpresa-NUMERO=" + this.reporteUsuarios.idEmpresa;

        this.reporteUsuarios.linkPdf = this.REPORT_USUARIOS +
            "formato=PDF&" +
            "authorization=" + jwtUtil.getJwtToken() + "&" +
            "idEmpresa-NUMERO=" + this.reporteUsuarios.idEmpresa;

        //REPORTE TRANSACCIONES

        this.tipoDocumento = [];
        this.tipoDocumento.push({label: 'Todos los Tipos', value: "-1"});
        this.tipoDocumento.push({label: 'Factura Electronica', value: "0"});
        this.tipoDocumento.push({label: 'Boleta Electronica', value: "1"});
        this.tipoDocumento.push({label: 'Nota de Debito', value: "2"});
        this.tipoDocumento.push({label: 'Nota de Credito', value: "3"});
        this.tipoDocumento.push({label: 'Percepciones', value: "4"});
        this.tipoDocumento.push({label: 'Retenciones', value: "5"});
        this.tipoDocumento.push({label: 'Guia de Remision', value: "6"});
        this.tipoDocumento.push({label: 'Resumen Diario', value: "7"});
        this.tipoDocumento.push({label: 'Resumen de Reversiones', value: "8"});
        this.tipoDocumento.push({label: 'Comunicación de Baja', value: "9"});

        this.reporteTransacciones.tipoDocumento = "-1";
        this.reporteTransacciones.rangoFechas = [new Date(fechaIni), new Date()];
        this.reporteTransacciones.idEmpresa = (this.empresaSession.id == "1") ? "-1" : this.empresaSession.id;
        this.reporteTransacciones.linkExcel = this.REPORT_TRANSACCIONES +
            "formato=EXCEL&" +
            "authorization=" + jwtUtil.getJwtToken() + "&" +
            "fechaDesde-FECHA=" + moment(this.reporteTransacciones.rangoFechas[0]).format("YYYY-MM-DD") + "&" +
            "fechaHasta-FECHA=" + moment(this.reporteTransacciones.rangoFechas[1]).format("YYYY-MM-DD") + "&" +
            "idEmpresa-NUMERO=" + ((this.reporteTransacciones.idEmpresa == "1") ? "-1" : this.reporteTransacciones.idEmpresa) + "&" +
            "tipoDoc-ENUMERADO=" + this.reporteTransacciones.tipoDocumento;

        this.reporteTransacciones.linkPdf = this.REPORT_TRANSACCIONES +
            "formato=PDF&" +
            "authorization=" + jwtUtil.getJwtToken() + "&" +
            "fechaDesde-FECHA=" + moment(this.reporteTransacciones.rangoFechas[0]).format("YYYY-MM-DD") + "&" +
            "fechaHasta-FECHA=" + moment(this.reporteTransacciones.rangoFechas[1]).format("YYYY-MM-DD") + "&" +
            "idEmpresa-NUMERO=" + ((this.reporteTransacciones.idEmpresa == "1") ? "-1" : this.reporteTransacciones.idEmpresa) + "&" +
            "tipoDoc-ENUMERADO=" + this.reporteTransacciones.tipoDocumento;

        //REPORTE ESTADISTICOS TRANSACCIONES
        this.reporteEstadisticoTransacciones.tipoDocumento = "-1";
        this.reporteEstadisticoTransacciones.idEmpresa = (this.empresaSession.id == "1") ? "-1" : this.empresaSession.id;
        this.reporteEstadisticoTransacciones.empresa = (this.empresaSession.id == "1") ? "" : this.empresaSession.nombre;
        this.reporteEstadisticoTransacciones.rangoFechas = [new Date(fechaIni), new Date()];
        this.reporteEstadisticoTransacciones.linkExcel = this.REPORT_ESTADISTICO_TRANSACCIONES +
            "formato=EXCEL&" +
            "authorization=" + jwtUtil.getJwtToken() + "&" +
            "fechaDesde-FECHA=" + moment(this.reporteEstadisticoTransacciones.rangoFechas[0]).format("YYYY-MM-DD") + "&" +
            "fechaHasta-FECHA=" + moment(this.reporteEstadisticoTransacciones.rangoFechas[1]).format("YYYY-MM-DD") + "&" +
            "idEmpresa-NUMERO=" + this.reporteEstadisticoTransacciones.idEmpresa + "&" +
            "empresa-TEXTO=" + this.reporteEstadisticoTransacciones.empresa + "&" +
            "tipoDoc-ENUMERADO=" + this.reporteEstadisticoTransacciones.tipoDocumento;

        this.reporteEstadisticoTransacciones.linkPdf = this.REPORT_ESTADISTICO_TRANSACCIONES +
            "formato=PDF&" +
            "authorization=" + jwtUtil.getJwtToken() + "&" +
            "fechaDesde-FECHA=" + moment(this.reporteEstadisticoTransacciones.rangoFechas[0]).format("YYYY-MM-DD") + "&" +
            "fechaHasta-FECHA=" + moment(this.reporteEstadisticoTransacciones.rangoFechas[1]).format("YYYY-MM-DD") + "&" +
            "idEmpresa-NUMERO=" + this.reporteEstadisticoTransacciones.idEmpresa + "&" +
            "empresa-TEXTO=" + this.reporteEstadisticoTransacciones.empresa + "&" +
            "tipoDoc-ENUMERADO=" + this.reporteEstadisticoTransacciones.tipoDocumento;

        //REPORTE TRANSACCIONES ERROR
        this.reporteTransaccionesError.tipoDocumento = "-1";
        this.reporteTransaccionesError.idEmpresa = this.empresaSession.id;
        this.reporteTransaccionesError.rangoFechas = [new Date(fechaIni), new Date()];
        this.reporteTransaccionesError.codigoError = "9999";
        this.reporteTransaccionesError.linkExcel = this.REPORT_TRANSACCIONES_ERROR +
            "formato=EXCEL&" +
            "authorization=" + jwtUtil.getJwtToken() + "&" +
            "fechaDesde-FECHA=" + moment(this.reporteTransaccionesError.rangoFechas[0]).format("YYYY-MM-DD") + "&" +
            "fechaHasta-FECHA=" + moment(this.reporteTransaccionesError.rangoFechas[1]).format("YYYY-MM-DD") + "&" +
            "idEmpresa-NUMERO=" + ((this.reporteTransaccionesError.idEmpresa == "1") ? "-1" : this.reporteTransaccionesError.idEmpresa) + "&" +
            "tipoDoc-ENUMERADO=" + this.reporteTransaccionesError.tipoDocumento + "&" +
            "codError-NUMERO=" + this.reporteTransaccionesError.codigoError;
        this.reporteTransaccionesError.linkPdf = this.REPORT_ESTADISTICO_TRANSACCIONES +
            "formato=PDF&" +
            "authorization=" + jwtUtil.getJwtToken() + "&" +
            "fechaDesde-FECHA=" + moment(this.reporteTransaccionesError.rangoFechas[0]).format("YYYY-MM-DD") + "&" +
            "fechaHasta-FECHA=" + moment(this.reporteTransaccionesError.rangoFechas[1]).format("YYYY-MM-DD") + "&" +
            "idEmpresa-NUMERO=" + ((this.reporteTransaccionesError.idEmpresa == "1") ? "-1" : this.reporteTransaccionesError.idEmpresa) + "&" +
            "tipoDoc-ENUMERADO=" + this.reporteTransaccionesError.tipoDocumento + "&" +
            "codError-NUMERO=" + this.reporteTransaccionesError.codigoError;

        //REPORTE TRANSACCIONES SUNAT
        this.reporteTransaccionesSunat.tipoDocumento = "-1";
        this.reporteTransaccionesSunat.idEmpresa = this.empresaSession.id;
        this.reporteTransaccionesSunat.rangoFechas = [new Date(fechaIni), new Date()];
        this.reporteTransaccionesSunat.linkExcel = this.REPORT_TRANSACCIONES_SUNAT +
            "formato=EXCEL&" +
            "authorization=" + jwtUtil.getJwtToken() + "&" +
            "fechaDesde-FECHA=" + moment(this.reporteTransaccionesSunat.rangoFechas[0]).format("YYYY-MM-DD") + "&" +
            "fechaHasta-FECHA=" + moment(this.reporteTransaccionesSunat.rangoFechas[1]).format("YYYY-MM-DD") + "&" +
            "idEmpresa-NUMERO=" + ((this.reporteTransaccionesSunat.idEmpresa == "1") ? "-1" : this.reporteTransaccionesSunat.idEmpresa) + "&" +
            "tipoDoc-ENUMERADO=" + this.reporteTransaccionesSunat.tipoDocumento;

        this.reporteTransaccionesSunat.linkPdf = this.REPORT_TRANSACCIONES_SUNAT +
            "formato=PDF&" +
            "authorization=" + jwtUtil.getJwtToken() + "&" +
            "fechaDesde-FECHA=" + moment(this.reporteTransaccionesSunat.rangoFechas[0]).format("YYYY-MM-DD") + "&" +
            "fechaHasta-FECHA=" + moment(this.reporteTransaccionesSunat.rangoFechas[1]).format("YYYY-MM-DD") + "&" +
            "idEmpresa-NUMERO=" + ((this.reporteTransaccionesSunat.idEmpresa == "1") ? "-1" : this.reporteTransaccionesSunat.idEmpresa) + "&" +
            "tipoDoc-ENUMERADO=" + this.reporteTransaccionesSunat.tipoDocumento;


    }


    ngOnInit() {
    }


//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┌┐┌┌┬┐┌─┐┬  ┬  ┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  ├─┘├─┤│││ │ ├─┤│  │  ├─┤
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  ┴  ┴ ┴┘└┘ ┴ ┴ ┴┴─┘┴─┘┴ ┴

    help() {
        $.getScript("./assets/layout/js/material-google.js", function () {
            setTimeout(function () {
                eval("$('#helpBusqueda').tapTarget('open');")
            }, 700);
            setTimeout(function () {
                eval("$('#helpBusqueda').tapTarget('close');")
            }, 5000);
        });
    }


//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┬─┐┬  ┬┬┌─┐┬┌─┐┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  └─┐├┤ ├┬┘└┐┌┘││  ││ │└─┐
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  └─┘└─┘┴└─ └┘ ┴└─┘┴└─┘└─┘


    consultarCombos() {
        // LLAMADO AL SERVICIO
        this.cargandoList = true;
        this.consumerService.post(WebServices.URL_GET_COMBOS_LOG_EMISOR)
            .subscribe(result => {
                this.emisores = [];
                this.emisores.push({label: 'Todos los contribuyentes', value: "-1"});

                $.each(result["comboCustomers"], (pos, item) => {
                    this.emisores.push({label: item.value, value: item.key});
                });
                this.cargandoList = false;
            }, err => {
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo listar las Emisores", this.router)

            });
    }

    ActualizarLinksReporteUsuario() {
        this.reporteUsuarios.linkExcel = this.REPORT_USUARIOS +
            "formato=EXCEL&" +
            "authorization=" + this.jwtUtil.getJwtToken() + "&" +
            "idEmpresa-NUMERO=" + this.reporteUsuarios.idEmpresa;

        this.reporteUsuarios.linkPdf = this.REPORT_USUARIOS +
            "formato=PDF&" +
            "authorization=" + this.jwtUtil.getJwtToken() + "&" +
            "idEmpresa-NUMERO=" + this.reporteUsuarios.idEmpresa;
    }

    actualizarLinksAuditoria() {
        this.reporteAuditoria.linkExcel = this.REPORT_AUDITORIA +
            "formato=EXCEL&" +
            "authorization=" + this.jwtUtil.getJwtToken() + "&" +
            "fechaDesde-FECHA=" + moment(this.reporteAuditoria.rangoFechas[0]).format("YYYY-MM-DD") + "&" +
            "fechaHasta-FECHA=" + moment(this.reporteAuditoria.rangoFechas[1]).format("YYYY-MM-DD");

        this.reporteAuditoria.linkPdf = this.REPORT_AUDITORIA +
            "formato=PDF&" +
            "authorization=" + this.jwtUtil.getJwtToken() + "&" +
            "fechaDesde-FECHA=" + moment(this.reporteAuditoria.rangoFechas[0]).format("YYYY-MM-DD") + "&" +
            "fechaHasta-FECHA=" + moment(this.reporteAuditoria.rangoFechas[1]).format("YYYY-MM-DD");

    }

    ActualizarLinksReporteTransacciones() {
        this.reporteTransacciones.linkExcel = this.REPORT_TRANSACCIONES +
            "formato=EXCEL&" +
            "authorization=" + this.jwtUtil.getJwtToken() + "&" +
            "fechaDesde-FECHA=" + moment(this.reporteTransacciones.rangoFechas[0]).format("YYYY-MM-DD") + "&" +
            "fechaHasta-FECHA=" + moment(this.reporteTransacciones.rangoFechas[1]).format("YYYY-MM-DD") + "&" +
            "idEmpresa-NUMERO=" + ((this.reporteTransacciones.idEmpresa == "1") ? "-1" : this.reporteTransacciones.idEmpresa) + "&" +
            "tipoDoc-ENUMERADO=" + this.reporteTransacciones.tipoDocumento;

        this.reporteTransacciones.linkPdf = this.REPORT_TRANSACCIONES +
            "formato=PDF&" +
            "authorization=" + this.jwtUtil.getJwtToken() + "&" +
            "fechaDesde-FECHA=" + moment(this.reporteTransacciones.rangoFechas[0]).format("YYYY-MM-DD") + "&" +
            "fechaHasta-FECHA=" + moment(this.reporteTransacciones.rangoFechas[1]).format("YYYY-MM-DD") + "&" +
            "idEmpresa-NUMERO=" + ((this.reporteTransacciones.idEmpresa == "1") ? "-1" : this.reporteTransacciones.idEmpresa) + "&" +
            "tipoDoc-ENUMERADO=" + this.reporteTransacciones.tipoDocumento;
    }


    ActualizarLinksReporteEstadisticos_Transacciones() {

        this.reporteEstadisticoTransacciones.empresa = this.obtenerNombreEmpresa(this.reporteEstadisticoTransacciones.idEmpresa);
        this.reporteEstadisticoTransacciones.linkExcel = this.REPORT_ESTADISTICO_TRANSACCIONES +
            "formato=EXCEL&" +
            "authorization=" + this.jwtUtil.getJwtToken() + "&" +
            "fechaDesde-FECHA=" + moment(this.reporteEstadisticoTransacciones.rangoFechas[0]).format("YYYY-MM-DD") + "&" +
            "fechaHasta-FECHA=" + moment(this.reporteEstadisticoTransacciones.rangoFechas[1]).format("YYYY-MM-DD") + "&" +
            "idEmpresa-NUMERO=" + this.reporteEstadisticoTransacciones.idEmpresa + "&" +
            "empresa-TEXTO=" + this.reporteEstadisticoTransacciones.empresa + "&" +
            "tipoDoc-ENUMERADO=" + this.reporteEstadisticoTransacciones.tipoDocumento;

        this.reporteEstadisticoTransacciones.linkPdf = this.REPORT_ESTADISTICO_TRANSACCIONES +
            "formato=PDF&" +
            "authorization=" + this.jwtUtil.getJwtToken() + "&" +
            "fechaDesde-FECHA=" + moment(this.reporteEstadisticoTransacciones.rangoFechas[0]).format("YYYY-MM-DD") + "&" +
            "fechaHasta-FECHA=" + moment(this.reporteEstadisticoTransacciones.rangoFechas[1]).format("YYYY-MM-DD") + "&" +
            "idEmpresa-NUMERO=" + this.reporteEstadisticoTransacciones.idEmpresa + "&" +
            "empresa-TEXTO=" + this.reporteEstadisticoTransacciones.empresa + "&" +
            "tipoDoc-ENUMERADO=" + this.reporteEstadisticoTransacciones.tipoDocumento;
    }

    ActualizarLinksReporteTransaccionesError() {
        this.reporteTransaccionesError.linkExcel = this.REPORT_TRANSACCIONES_ERROR +
            "formato=EXCEL&" +
            "authorization=" + this.jwtUtil.getJwtToken() + "&" +
            "fechaDesde-FECHA=" + moment(this.reporteTransaccionesError.rangoFechas[0]).format("YYYY-MM-DD") + "&" +
            "fechaHasta-FECHA=" + moment(this.reporteTransaccionesError.rangoFechas[1]).format("YYYY-MM-DD") + "&" +
            "idEmpresa-NUMERO=" + ((this.reporteTransaccionesError.idEmpresa == "1") ? "-1" : this.reporteTransaccionesError.idEmpresa) + "&" +
            "tipoDoc-ENUMERADO=" + this.reporteTransaccionesError.tipoDocumento + "&" +
            "codError-NUMERO=" + this.reporteTransaccionesError.codigoError;

        this.reporteTransaccionesError.linkPdf = this.REPORT_TRANSACCIONES_ERROR +
            "formato=PDF&" +
            "authorization=" + this.jwtUtil.getJwtToken() + "&" +
            "fechaDesde-FECHA=" + moment(this.reporteTransaccionesError.rangoFechas[0]).format("YYYY-MM-DD") + "&" +
            "fechaHasta-FECHA=" + moment(this.reporteTransaccionesError.rangoFechas[1]).format("YYYY-MM-DD") + "&" +
            "idEmpresa-NUMERO=" + ((this.reporteTransaccionesError.idEmpresa == "1") ? "-1" : this.reporteTransaccionesError.idEmpresa) + "&" +
            "tipoDoc-ENUMERADO=" + this.reporteTransaccionesError.tipoDocumento + "&" +
            "codError-NUMERO=" + this.reporteTransaccionesError.codigoError;
    }

    ActualizarLinksReporteTransaccionesSunat() {
        this.reporteTransaccionesSunat.linkExcel = this.REPORT_TRANSACCIONES_SUNAT +
            "formato=EXCEL&" +
            "authorization=" + this.jwtUtil.getJwtToken() + "&" +
            "fechaDesde-FECHA=" + moment(this.reporteTransaccionesSunat.rangoFechas[0]).format("YYYY-MM-DD") + "&" +
            "fechaHasta-FECHA=" + moment(this.reporteTransaccionesSunat.rangoFechas[1]).format("YYYY-MM-DD") + "&" +
            "idEmpresa-NUMERO=" + ((this.reporteTransaccionesSunat.idEmpresa == "1") ? "-1" : this.reporteTransaccionesSunat.idEmpresa) + "&" +
            "tipoDoc-ENUMERADO=" + this.reporteTransaccionesSunat.tipoDocumento;

        this.reporteTransaccionesSunat.linkPdf = this.REPORT_TRANSACCIONES_SUNAT +
            "formato=PDF&" +
            "authorization=" + this.jwtUtil.getJwtToken() + "&" +
            "fechaDesde-FECHA=" + moment(this.reporteTransaccionesSunat.rangoFechas[0]).format("YYYY-MM-DD") + "&" +
            "fechaHasta-FECHA=" + moment(this.reporteTransaccionesSunat.rangoFechas[1]).format("YYYY-MM-DD") + "&" +
            "idEmpresa-NUMERO=" + ((this.reporteTransaccionesSunat.idEmpresa == "1") ? "-1" : this.reporteTransaccionesSunat.idEmpresa) + "&" +
            "tipoDoc-ENUMERADO=" + this.reporteTransaccionesSunat.tipoDocumento;
    }

    obtenerNombreEmpresa(value) {
        let nombre = "TODOS";
        $.each(this.emisores, function (pos, item) {
            if (value == item.value)
                nombre = item.label;
        });
        return nombre;
    }
}




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/reporte/general/general.component.ts